import { useState, Fragment } from 'react'
import { FetchPostDestinations } from 'components/Fetch'
import { Outlet, useLocation } from 'react-router'
import { useSelector } from 'react-redux'
import { bucketsSelector } from 'services/post/selectors'
import { FetchBuckets } from 'components/Fetch/FetchBuckets'

export function HistoryRoute() {
  const buckets = useSelector(bucketsSelector)
  const [loading, setLoading] = useState(buckets.length === 0)

  const onLoaded = () => setLoading(false)

  if (loading) {
    return <FetchBuckets onError={onLoaded} onFetched={onLoaded} />
  }

  return (
    <Fragment>
      <Outlet />
      <FetchPostDestinations force={false} />
    </Fragment>
  )
}

export default HistoryRoute
